import axios from 'axios'

export default {
  status: () => axios.get('emergency/status'),
  resume: (data) => axios.post('emergency/resume-json', data),
}
